import { z } from 'zod';

export const documentFieldDefinition = z.object({
  id: z.string(),
  name: z.string(),
});
export type DocumentFieldDefinition = z.infer<typeof documentFieldDefinition>;

const boundingBox = z.object({
  pageNumber: z.number(),
  x1: z.number(),
  y1: z.number(),
  x2: z.number(),
  y2: z.number(),
  width: z.number(),
  height: z.number(),
});

export type BoundingBox = z.infer<typeof boundingBox>;

export interface DocumentField {
  fieldId: string;
  field: string;
  value: string;

  sourceBoundingBox?: BoundingBox;
}

// Prefer createFundRequest from types.server.ts
export const setDocumentFieldRequest = z
  .object({
    fieldId: z.string(),
    fieldValue: z.string(),
    isPresent: z.boolean(),
    boundingBox: boundingBox.nullable(),
  })
  .strict();

// Prefer CreateFundRequest from types.server.ts
export type SetDocumentFieldRequest = z.infer<typeof setDocumentFieldRequest>;

export type FieldManager = {
  documentId: string;
  fieldId: string | null;
  updating: boolean;
  error: boolean;
};
